export default "__VITE_ASSET__Dz93xiwx__"